import { Box, Breadcrumbs, Button, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import { GLOBALLIST } from "../../constant/endpoint";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useStyles } from "../../constant/constant";
import Paper from '@mui/material/Paper';
import moment from "moment";

export const GlobalManager = () => {
    const [globalList,setGlobalList] = useState({})
    const [value, setValue] = React.useState('1');
    const classes = useStyles();
    useEffect(()=>{
        getGlobalList()
    },[])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getGlobalList = async () => {
        const result = await axios.get(GLOBALLIST)
        if(result?.data?.status === 'success'){
            setGlobalList(result?.data?.data)
        }
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/global'} >
            <h4>Global Manager</h4>
        </Link>
    ];
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab label="QUIZ PLAY Global" value="1" />
                                <Tab label="Trading Global" value="2" />
                                <Tab label="Skiller Global" value="3" />
                            </TabList>
                        </Box>
                        <TabPanel style={{padding:"0px"}} value="1">
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Match Id</TableCell>
                                        <TableCell>Question</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>End Time</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            globalList[0]?.InPlay?.map((data, index) =>
                                                <TableRow>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell text-align="center">{data.match_id}</TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell style={{ color: data.status === 1 ?"green" :"red" }}>{data.status === 1 ? "Active" : "InActive"}</TableCell>
                                                    <TableCell>{moment(data.predic_end_time).format('YYYY-MM-DD HH:MM')}</TableCell>
                                                    <TableCell>
                                                    <Link style={{ color: "#000", fontWeight: "600" }} variant={'contained'} size='small' color={'warning'} to={`/matchlist/in_play/${data.match_id}/${data.series_id}/${data.sport}`}>Go to Quiz Play</Link>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel style={{padding:"0px"}} value="2">
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Match Id</TableCell>
                                        <TableCell>Question</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>End Time</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            globalList[1]?.trade?.map((data, index) =>
                                                <TableRow>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{data.match_id}</TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell style={{ color: data.status === 1 ?"green" :"red" }}>{data.status === 1 ? "Active" : "InActive"}</TableCell>
                                                    <TableCell>{moment(data.predic_end_time).format('YYYY-MM-DD')}</TableCell>
                                                    <TableCell>
                                                        <Link style={{ color: "#000", fontWeight: "600" }} variant={'contained'} size='small' color={'warning'} to={`/matchlist/trading/${data.match_id}/${data.series_id}/${data.sport}`}>Go to Trading</Link>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel style={{padding:"0px"}} value="3">
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Match Id</TableCell>
                                        <TableCell>Question</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>End Time</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            globalList[2]?.skillerList?.map((data, index) =>
                                                <TableRow>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{data.match_id}</TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell style={{ color: data.status === 1 ?"green" :"red" }}>{data.status === 1 ? "Active" : "InActive"}</TableCell>
                                                    <TableCell>{moment(data.predic_end_time).format('YYYY-MM-DD')}</TableCell>
                                                    <TableCell>
                                                        <Link style={{ color: "#000", fontWeight: "600" }} variant={'contained'} size='small' color={'warning'} to={`/matchlist/skiller/${data.match_id}/${data.series_id}/${data.sport}`}>Go to Skiller</Link>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                    </TabContext>
                </Box>
                </div>
            </div>
        </>
    )
}